import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDislikeBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "dislike" }), /* @__PURE__ */ _jsx("path", { d: "M.25,12.435a2.253,2.253,0,0,0,2.25,2.25H9.226a.25.25,0,0,1,.244.306,25.026,25.026,0,0,0-.72,4.725,3.35,3.35,0,0,0,.757,2.3,2.349,2.349,0,0,0,1.748.8,1.9,1.9,0,0,0,1.995-1.88A7.193,7.193,0,0,1,20,13.685h3a.75.75,0,0,0,.75-.75v-9a.75.75,0,0,0-.75-.75c-4.532,0-6.009-.635-7.312-1.193A8.044,8.044,0,0,0,12,1.185H5.5A2.251,2.251,0,0,0,3.481,4.429a2.251,2.251,0,0,0-1,3,2.251,2.251,0,0,0-1,3A2.251,2.251,0,0,0,.25,12.435Z" })]
});
export default SvgDislikeBold;
